import JobsTable from "../../Components/Admin/Jobs/JobsTable";

function Jobs() {
  return <JobsTable />;
}

export default Jobs;
